import { z } from "zod";
import { AvatarSVG, WorkspaceRole, InvitationStatus, Plan, Theme, ProfileSetupStep } from './enums';

export const WorkspacePermission = z.object({
  role: WorkspaceRole,
  id: z.string(),
  userId: z.string(),
  workspaceId: z.string(),
})
export type WorkspacePermission = z.infer<typeof WorkspacePermission>;

export const Workspace = z.object({
  plan: Plan.nullable(),
  id: z.string(),
  stripeCustomerId: z.string().nullable(),
  name: z.string(),
  avatarUrl: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})
export type Workspace = z.infer<typeof Workspace>;

export const CompressedWorkspace = z.object({
  id: z.string(),
  name: z.string(),
  avatarUrl: z.string().nullable(),
})
export type CompressedWorkspace = z.infer<typeof CompressedWorkspace>;

export const WorkspaceCharges = z.object({
  description: z.string().nullable(),
  id: z.string(),
  date: z.date(),
  status: z.string(),
  amount: z.number(),
})
export type WorkspaceCharges = z.infer<typeof WorkspaceCharges>;

export const WorkspaceTeamMember = z.object({
  theme: Theme.nullable(),
  profileSetupStep: ProfileSetupStep,
  id: z.string(),
  name: z.string(),
  image: z.string().nullable(),
  email: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  lastSeen: z.coerce.date().nullish(),
  emailVerified: z.coerce.date().nullable(),
  isAdmin: z.boolean(),
  hasViewedWorkspaceOnboarding: z.boolean(),
  hasViewedEditorOnboarding: z.boolean(),
  hasPassword: z.boolean().nullish(),
  workspaces: z.array(z.object({ id: z.string(), role: WorkspaceRole })).optional(),
  memberId: z.string(),
  role: WorkspaceRole,
})
export type WorkspaceTeamMember = z.infer<typeof WorkspaceTeamMember>;

export const WorkspaceInvitation = z.object({
  status: InvitationStatus,
  role: WorkspaceRole,
  id: z.string(),
  email: z.string(),
  workspaceId: z.string(),
  name: z.string(),
})
export type WorkspaceInvitation = z.infer<typeof WorkspaceInvitation>;

export const WorkspaceSearchItem = z.object({
  title: z.string(),
  description: z.string(),
  link: z.string(),
  image: z.string().nullable(),
  icon: z.string().nullable(),
  avatar: z.object({
    avatar: AvatarSVG.nullable(),
    color: z.string().nullable()
  }).nullish(),
})
export type WorkspaceSearchItem = z.infer<typeof WorkspaceSearchItem>;